import styles from './premium.module.scss';
import { Stack, Typography } from '@mui/material';
import classnames from 'classnames';
import Routes from 'data/routes';
import withPremium from 'hocs/withPremium';
import { useRouter } from 'next/navigation';
import { Button, Icon } from 'ui';

const Compact = () => {
  const router = useRouter();

  return (
    <Stack className={classnames(styles.root, styles.compact)}>
      <Icon name="diamond" />
      <Typography variant="h3">Hazte premium</Typography>
      <Typography variant="span">
        Obtén acceso a contenido exclusivo.
      </Typography>
      <Button
        color="white"
        onClick={() => router.push(Routes.subscription)}
        size="small"
        rounded
      >
        Suscribirse
      </Button>
    </Stack>
  );
};

export default withPremium(Compact);
